import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";

const useDashboardList = () => {
  const {
    lists,
  } = useSelector((state) => ({
    users: state.users,
    org: state.org,
    lists: state.lists,
  }));
  const { listType, id } = useParams();
  const [listData, setListData] = useState();

  useEffect(() => {
    setListData(lists[listType]);
  }, [lists]);
  

  return {
    listData: listData,
    listType,
    id,
    loading: lists?.loading,
  };
};

export { useDashboardList };
